import { AdvertEntity } from './Advert'
import { ChannelEntity } from './Channel'
import { TelegramAccountEntity } from './TelegramAccount'

export interface SendingScheduleProps {
  uuid: string
  adverts: AdvertEntity[]
  channel: ChannelEntity
  telegramAccount: TelegramAccountEntity
  accountId: number
  defaultSendingIntervalSeconds: number
  isActive: boolean
  createdAt: Date
  updatedAt?: Date
}

export class SendingScheduleEntity {
  private readonly props: SendingScheduleProps
  private constructor(props: SendingScheduleProps) { this.props = { ...props } }
  static create(props: SendingScheduleProps) { return new SendingScheduleEntity(props) }
  get uuid() { return this.props.uuid }
  get adverts() { return [...this.props.adverts] }
  get channel() { return this.props.channel }
  get telegramAccount() { return this.props.telegramAccount }
  get accountId() { return this.props.accountId }
  get defaultSendingIntervalSeconds() { return this.props.defaultSendingIntervalSeconds }
  get isActive() { return this.props.isActive }
  get createdAt() { return this.props.createdAt }
  get updatedAt() { return this.props.updatedAt }
}
